// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapComponent_mapWrapper__cD88o {
  position: relative;
  height: 100%;
  width: 100%;
}

.MapComponent_mapButtons__hRgrj {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  padding: 6px 10px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  gap: 8px;
}

.MapComponent_mapButton__ZabPz {
  padding: 4px 10px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  color: #000;
  transition: background 0.2s, color 0.2s;
}

.MapComponent_mapButtonActive__7aT4z {
  background: #4a6cf7;
  color: #fff;
}


`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/map/MapComponent.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".mapWrapper {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.mapButtons {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1000;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.mapButton {\r\n  padding: 4px 10px;\r\n  font-size: 13px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  background: #fff;\r\n  color: #000;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.mapButtonActive {\r\n  background: #4a6cf7;\r\n  color: #fff;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapWrapper": `MapComponent_mapWrapper__cD88o`,
	"mapButtons": `MapComponent_mapButtons__hRgrj`,
	"mapButton": `MapComponent_mapButton__ZabPz`,
	"mapButtonActive": `MapComponent_mapButtonActive__7aT4z`
};
export default ___CSS_LOADER_EXPORT___;
